import { render, staticRenderFns } from "./item3.vue?vue&type=template&id=6a772bdc&scoped=true"
import script from "./item3.vue?vue&type=script&lang=js"
export * from "./item3.vue?vue&type=script&lang=js"
import style0 from "./item3.vue?vue&type=style&index=0&id=6a772bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a772bdc",
  null
  
)

export default component.exports